// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"febaf04b","924":"febaf04b","3681":"bd99d48d","3908":"febaf04b","6252":"bd99d48d","7393":"6642be4a","7431":"f63e0ce0","7852":"febaf04b","8728":"393365a7","8851":"bd99d48d"}[chunkId] + ".chunk.css";
};